module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_7016.f50c2349.png";